import { Component, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import {DeviceStatus, EquipmentDetails, Point} from "src/app/models/dashboard";
import { BackendService } from "src/app/services/backend/backend.service";
import { Operation } from "src/app/config/constants";

@Component({
    selector: "cc-equipment-details-view",
    templateUrl: "./details-view.component.html",
    styleUrls: ["./details-view.component.scss"],
    standalone: false,
})
export class EquipmentDetailsViewComponent implements OnInit {
    @Input() equipmentDetails: EquipmentDetails;
	@Input() username: string;
	@Input() selectedSite: { siteId: string, customerId: string };
    @Input() pointsStatus: { [key: string]: DeviceStatus } = {};

    showScheduleDialog: boolean = false;
    showExceptionScheduleDialog: boolean = false;
    selectedScheduleUUID: string = "";
    selectedExceptionScheduleUUID: string = "";
    equipmentLink: string;
    pointsObj: { [key: string]: { [key: string]: Point[] } } = {};

    isOverrideResetOn: boolean = false;
    userHasWritePermission$: Observable<boolean>;
	category = 'equipment';


    constructor(private backendService: BackendService) {}

    ngOnInit(): void {
		const equipmentId = this.equipmentDetails.uri.split(':').pop();
		this.equipmentLink = `${window.location.origin}/customers/${this.selectedSite.customerId}/sites/${this.selectedSite.siteId}/equipments/${equipmentId}`;
    }

    showSchedule(pointUUID: string) {
        this.selectedScheduleUUID = pointUUID;
        this.showScheduleDialog = true;
    }

    showExceptionSchedule(pointUUID: string) {
        this.selectedExceptionScheduleUUID = pointUUID;
        this.showExceptionScheduleDialog = true;
    }

	togglePin(event: MouseEvent, equipment: EquipmentDetails) {
        event.stopPropagation();
        const operation = equipment.pinned ? Operation.Delete : Operation.Add;
        this.backendService
            .entityAddRemovePin(
                this.category,
                this.username,
                this.selectedSite,
                operation,
                equipment.uri
            )
            .subscribe(
                () => {
                    equipment.pinned = !equipment.pinned;
                },
                (err) => {
                    console.log(err);
                }
            );
    }
}
